import { authClient, API } from "../index";

export const getArchivosByUsuario = (userId) => {
  return authClient().get(`${API}/archivo/usuario/${userId}`);
};

export const downloadArchivo = (archivoId) => {
  return authClient().get(`${API}/archivo/${archivoId}/descargar`, {
    responseType: "blob",
  });
};
